export default __webpack_public_path__ + "052179afc9000208e5f5bc8cbb4bb1f3.png";